const mockAgents = [
    {
      id: "1",
      name: "Dr. K H Lasantha Goonewardena",
      specialty: "Managing Diretor & Realtor",
      email: "lasa_ray@yahoo.com",
      contact: "+94777727527",
      image: "https://i.imgur.com/rdU5cbb.jpeg", // Replace with actual image paths
      describe: 'A visionary leader committed to sustainable real estate development and innovation.',

    },
    {
      id: "2",
      name: "Dan Yabesh Poddiwela",
      specialty: "Realtor",
      email: "danpoddi@gmail.com",
      contact: "+94771125807",
      image: "https://i.imgur.com/2tS1fH7.jpeg", // Replace with actual image paths
      describe: 'Dedicated to providing exceptional service and finding dream homes for clients.',

    },
    {
      id: "3",
      name: "Shamika Chandupa Manikrathne",
      specialty: "Social Media Strategist",
      email: "s.chandupa2005@gmail.com",
      contact: "+94726645529",
      image: "https://i.imgur.com/Pg3lwxo.jpeg", // Replace with actual image paths
      describe: "Combines graphic design expertise with strategic marketing for impactful campaigns.",
    },
    {
      id: "4",
      name: "Dimantha Kalhara Goonewardena",
      specialty: "Software Developer",
      email: "goonewardenadimantha@gmail.com",
      contact: "+14164746869",
      image: "https://i.imgur.com/6ele5Se.png", // Replace with actual image paths
      website: "www.dimanthagoonewardena.com",
    },
  ];
  
  export default mockAgents;
  